import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgHelpdeskFullLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 170,
	height: 32,
	viewBox: "0 0 170 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "HelpDesk Logo",
		children: [/* @__PURE__ */ _jsxs("g", {
			id: "Wordmark",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector",
					d: "M44.7861 26.0862H49.0497V17.1033H57.7738V26.0862H62.0373V4.32617H57.7738V13.2587H49.0497V4.32617H44.7861V26.0862Z",
					fill: "#1B1B20"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M71.7554 26.4605C75.2576 26.4605 78.088 24.3165 78.6389 21.3634H75.0157C74.6172 22.4788 73.5199 23.4114 71.7554 23.4114C69.3504 23.4114 68.4055 21.7656 68.4055 19.8685V19.4662H78.7598V16.6365C78.7598 12.7508 76.3862 9.55078 71.6927 9.55078C66.9992 9.55078 64.3838 12.6594 64.3838 17.0388V19.2468C64.3838 23.7725 67.2769 26.4605 71.7554 26.4605ZM68.4055 16.3256C68.4055 14.1496 69.3012 12.5314 71.6927 12.5314C73.932 12.5314 74.953 14.0582 74.953 16.0788V16.4811H68.4055V16.3256Z",
					fill: "#1B1B20"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					d: "M80.874 26.0851H85.0166V3.39258H80.874V26.0851Z",
					fill: "#1B1B20"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_4",
					d: "M96.5034 9.55078C94.2194 9.55078 92.6072 10.6068 91.8145 11.8365V9.92107H87.8555V31.4936H91.9981V24.3439C92.8221 25.5874 94.4344 26.4605 96.5348 26.4605C100.798 26.4605 103.176 23.2285 103.176 19.3428V16.6685C103.176 12.8422 100.861 9.55078 96.5034 9.55078ZM95.5003 12.9702C97.9052 12.9702 99.0338 14.7074 99.0338 16.8559V19.1416C99.0338 21.4274 97.8157 23.0274 95.451 23.0274C93.5656 23.0274 91.9802 21.6559 91.9802 19.2011V16.8559C91.9981 14.5839 93.3999 12.9702 95.5003 12.9702Z",
					fill: "#1B1B20"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_5",
					d: "M105.523 4.32617V26.0862H114.171C119.899 26.0862 122.913 22.4793 122.913 17.5376V12.8747C122.913 7.93303 119.899 4.32617 114.171 4.32617H105.523ZM118.681 17.5833C118.681 20.7559 116.89 22.557 113.441 22.557H109.756V7.86903H113.441C116.881 7.86903 118.681 9.67474 118.681 12.8427V17.5833Z",
					fill: "#1B1B20"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_6",
					d: "M131.96 26.4605C135.463 26.4605 138.293 24.3165 138.839 21.3634H135.216C134.822 22.4788 133.725 23.4114 131.96 23.4114C129.551 23.4114 128.611 21.7656 128.611 19.8685V19.4662H138.965V16.6365C138.965 12.7508 136.587 9.55078 131.898 9.55078C127.209 9.55078 124.589 12.6594 124.589 17.0388V19.2468C124.589 23.7725 127.482 26.4605 131.96 26.4605ZM128.611 16.3256C128.611 14.1496 129.506 12.5314 131.898 12.5314C134.137 12.5314 135.158 14.0582 135.158 16.0788V16.4811H128.611V16.3256Z",
					fill: "#1B1B20"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_7",
					d: "M147.138 26.4598C151.065 26.4598 153.99 24.1741 153.99 21.0518C153.99 18.7661 152.803 17.5044 150.456 16.9375L145.646 15.7261C144.822 15.5386 144.428 15.1684 144.428 14.3546C144.428 13.2026 145.324 12.5809 147.017 12.5809C148.844 12.5809 149.605 13.4541 149.605 14.6975V14.9764H153.228V14.7249C153.228 11.5249 150.761 9.56836 146.958 9.56836C143.156 9.56836 140.563 11.3969 140.563 14.7249C140.563 17.1844 141.813 18.4278 144.186 18.9855L148.88 20.0735C149.775 20.2929 150.187 20.7592 150.187 21.5364C150.187 22.7798 148.907 23.4929 147.173 23.4929C145.225 23.4929 143.976 22.6518 143.976 21.2529V21.0289H140.321V21.3078C140.317 24.7501 143.116 26.4598 147.138 26.4598Z",
					fill: "#1B1B20"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_8",
					d: "M155.822 26.0851H159.965V18.1903L165.169 26.0851H169.889L164.255 17.8291L169.71 9.92058H164.99L159.965 17.4451V3.39258H155.822V26.0851Z",
					fill: "#1B1B20"
				})
			]
		}), /* @__PURE__ */ _jsx("g", {
			id: "Mark",
			children: /* @__PURE__ */ _jsx("path", {
				id: "Vector_9",
				d: "M17.914 14.0297L27.0367 5.94286H17.914C14.685 5.94286 11.4739 6.05257 8.41958 6.26743C7.82261 6.30316 7.25799 6.55621 6.82822 6.98063C6.39845 7.40506 6.13202 7.97273 6.07732 8.58057C5.92953 10.5143 5.82205 12.928 5.82205 15.3326V16.6674C5.82205 19.072 5.92058 21.472 6.07284 23.4011C6.12779 24.0092 6.39502 24.5769 6.8258 25.0007C7.25657 25.4245 7.82221 25.6761 8.41958 25.7097C14.7432 26.1531 21.0892 26.1531 27.4129 25.7097C28.0098 25.676 28.5748 25.4242 29.0049 25.0003C29.4349 24.5765 29.7012 24.0089 29.7551 23.4011C29.8985 21.5726 29.9835 19.328 30.0015 17.056L35.828 11.8857C35.828 11.8857 35.828 15.4514 35.828 16.6537V17.0423C35.828 19.4697 35.716 21.8834 35.5638 23.8629C35.3972 25.8872 34.5262 27.7838 33.1083 29.2093C31.6904 30.6348 29.8194 31.4951 27.8339 31.6343C24.6317 31.8811 21.2729 32 17.914 32C14.5551 32 11.1962 31.8811 8.00308 31.6526C6.01609 31.5142 4.14341 30.6538 2.7245 29.2273C1.30558 27.8007 0.434344 25.9025 0.26871 23.8766C0.107484 21.792 0 19.2274 0 16.6674V15.3326C0 12.768 0.111962 10.2034 0.26871 8.11886C0.435484 6.09427 1.30733 4.19767 2.72623 2.7728C4.14514 1.34794 6.01719 0.489121 8.00308 0.352C11.1962 0.118857 14.5506 0 17.914 0H35.828V5.94286L17.914 21.8149L9.54368 14.4046L13.9416 10.5143L17.914 14.0297Z",
				fill: "#2FC774"
			})
		})]
	})
});
export default SvgHelpdeskFullLogo;
